import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import PercentageProgressListItem from '/component/base/PercentageProgressListItem';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {CoachInfoCard} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {capGQV} from '/util/attribute.util';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './NewCoachesReportContent.style';
interface RecordData {
  businessCoach?: {
    firstName?: string;
    lastName?: string;
  };
  orderingEntitiesCount?: number;
  earnedQsb?: boolean;
  activatedOn?: string;
  gqv?: {
    current?: string | number;
    target?: string | number;
  };
}
interface NewCoachesReportContentProps {
  tt: (key: string, fallback: string) => string;
  recordData: RecordData;
  renderTitle: () => string;
}

export const NewCoachesReportContent: React.FC<
  NewCoachesReportContentProps
> = ({tt, recordData = {}, renderTitle = () => ''}) => {
  const {
    businessCoach: {firstName, lastName} = {},
    orderingEntitiesCount,
    earnedQsb,
    activatedOn,
    gqv: {current: currentGqv, target: targetGqv} = {},
  } = recordData;

  const earnedQsbText = earnedQsb
    ? tt('earnedBonus', 'Yes')
    : tt('didNotEarnBonus', 'No');

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">{renderTitle()}</Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('activationDate', 'Activation Date')}</Text>}
          suffix={
            <Text variant="button">{`${getDateUtilDefaultInstance().formatDate(
              activatedOn,
              'MMMM d, yyyy',
            )}`}</Text>
          }
          testID={CoachInfoCard.activationDateContent}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('businessCoach', 'Business Coach')}</Text>}
          suffix={<Text variant="button">{`${firstName} ${lastName}`}</Text>}
          testID={CoachInfoCard.businessCoachContent}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('bonus', 'Earned Quick Start Bonus')}</Text>}
          suffix={<Text variant="button">{earnedQsbText}</Text>}
          testID={CoachInfoCard.earnedQSBContent}
        />
      </Gutter>
      <Gutter>
        <PercentageProgressListItem
          style={{
            listItem: {base: styles.listItem},
          }}
          readonly={true}
          label={
            <Text>
              {tt(
                'groupVolume',
                'Group Qualifying Volume for Senior Coach Rank',
              )}
            </Text>
          }
          numerator={parseInt(capGQV(currentGqv), 10)}
          denominator={parseInt(capGQV(targetGqv), 10)}
          oneLineLayout={true}
          testID={CoachInfoCard.gqvContent}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('orderingEntities', 'Ordering Entities')}</Text>}
          suffix={<Text variant="button">{orderingEntitiesCount}</Text>}
          testID={CoachInfoCard.oeContent}
        />
      </Gutter>
    </View>
  );
};

export default withTranslation('reportCardContent.newCoaches')(
  NewCoachesReportContent,
);
